import { FormInstance, type Rule } from "antd/lib/form"
import { Moment } from "moment"
import { checkMaxDate, checkMinDate } from "./utils.rules"

export const createDateRangeRules = ({ formInstance, minDateName, maxDateName }: { formInstance: FormInstance; minDateName: string; maxDateName: string }) => ({
    minDate: [
        {
            validator: (_rule, value: Moment) => checkMinDate({ formInstance, value, name: maxDateName }),
        },
    ] as Array<Rule>,
    maxDate: [
        {
            validator: (_rule, value: Moment) => checkMaxDate({ formInstance, value, name: minDateName }),
        },
    ] as Array<Rule>,
})
